import { render, staticRenderFns } from "./financeiro-calculo-teto.vue?vue&type=template&id=677b959d&scoped=true"
import script from "./financeiro-calculo-teto.vue?vue&type=script&lang=ts"
export * from "./financeiro-calculo-teto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b959d",
  null
  
)

export default component.exports